import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LEGEND = [
  { color: "#8a5a2e", label: "Ruoste ja metallihiukkaset" },
  { color: "#7d9c63", label: "Kloori" },
  { color: "#6b6f76", label: "Hieno pöly ja sedimentti" },
  { color: "#6fb6dd", label: "Puhdas vesi" },
];

export default function FiltrationExperience() {
  return (
    <section
      id="suodatus"
      data-testid="filtration-section"
      className="relative overflow-hidden bg-primary py-24 md:py-36"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5 relative z-10">
            <p className="eyebrow text-primary-foreground/60">Opetusvideo</p>
            <h2 className="h-section font-heading mt-5 font-semibold text-white" lang="fi">
              Katso, miten suodatin toimii.
            </h2>
            <p className="mt-6 max-w-md text-base md:text-lg leading-relaxed text-primary-foreground/80">
              Vesi virtaa läpinäkyvän suodatinpatruunan läpi. Ruoste, kloori ja sedimentti jäävät
              tiheään suodatinmateriaaliin – ulos virtaa kirkkaampi, puhtaampi vesi.
            </p>
            <ul className="mt-8 space-y-3">
              {LEGEND.map((l) => (
                <li key={l.label} className="flex items-center gap-3 text-sm font-semibold text-primary-foreground/90">
                  <span className="h-3 w-3 rounded-full" style={{ backgroundColor: l.color }} />
                  {l.label}
                </li>
              ))}
            </ul>
            <Link
              to="/kauppa/"
              data-testid="filtration-cta"
              className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-white px-7 py-3.5 text-sm font-bold text-primary transition-transform duration-200 hover:scale-[1.04]"
            >
              Tutustu suodattimiin <ArrowRight size={17} />
            </Link>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <div className="grid gap-5 sm:grid-cols-2">
              <figure>
                <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-black/30">
                  <video
                    controls
                    preload="metadata"
                    playsInline
                    className="aspect-[4/5] w-full bg-black"
                    data-testid="install-video"
                  >
                    <source src="/videos/jinsu-asennusohje.mp4" type="video/mp4" />
                    Selaimesi ei tue videotoistoa.
                  </video>
                </div>
                <figcaption className="mt-3 text-center text-xs font-semibold uppercase tracking-widest text-primary-foreground/60">
                  Asennus hanaan
                </figcaption>
              </figure>
              <figure>
                <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-black/30">
                  <video
                    controls
                    preload="metadata"
                    playsInline
                    className="aspect-[4/5] w-full bg-black"
                    data-testid="install-video-handheld"
                  >
                    <source src="/videos/jinsu-asennusohje-kasisuihku.mp4" type="video/mp4" />
                    Selaimesi ei tue videotoistoa.
                  </video>
                </div>
                <figcaption className="mt-3 text-center text-xs font-semibold uppercase tracking-widest text-primary-foreground/60">
                  Asennus käsisuihkuun
                </figcaption>
              </figure>
            </div>
            <p className="mt-4 text-center text-xs font-semibold uppercase tracking-widest text-primary-foreground/50">
              Ohjevideot: näin suodatin asennetaan
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
